import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState
} from "react"

export interface CompanyHomeContextType {
  unreadMessagesCount?: number
}

export const CompanyHomeContext = createContext<CompanyHomeContextType>({
  unreadMessagesCount: 0
})

export const CompanyHomeContextProvider = ({ children }: { children: any }) => {
  const [unreadMessagesCount, setUnreadMessagesCount] = useState(0)

  const onEventBusEvent = useCallback((event) => {
    if (event.detail?.payload?.unread_messages_count !== undefined) {
      setUnreadMessagesCount(event.detail?.payload?.unread_messages_count)
    }
  }, [])

  useEffect(() => {
    document.addEventListener("Home", onEventBusEvent)
  }, [])

  const contextValue = {
    unreadMessagesCount,
    a: 1
  }
  return (
    <CompanyHomeContext.Provider value={contextValue}>
      {children}
    </CompanyHomeContext.Provider>
  )
}

export const useCompanyHomeContext = (): CompanyHomeContextType =>
  useContext(CompanyHomeContext) as CompanyHomeContextType
